<template>
  <div class="footer_introduce">
			<div class="margin">
				<div class="txt"><a style="color: inherit" href="http://beian.miit.gov.cn/">蜀ICP备19010368-4</a>   川网文【2019】2787-154号</div>
				<div class="txt">健康游戏公告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防上当受骗 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</div>
				<div class="txt">未满18周岁的未成年人用户请在家长的监督下进行游戏</div>
				<p class="txt">闲徕互娱（成都）网络科技有限公司版权所有</p>
			</div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
	 @import '../../components/style/mixin';
	.footer_introduce {
	  width:100%;
	  height:100%;
	  background-color:#282828;
	  .margin{
	  	padding:35px 0px;
	  	.txt{
	  		line-height:30px;
		  	text-align: center;
		  	@include sc(14px, #a1a1a1);
	  	}
	  }
	}
</style>
